module.exports = __webpack_public_path__ + "static/media/github-actions.8e7e349f.png";